const breakpoints = ["40em", "56em", "64em"];

export default breakpoints;
